




























exports.default =
  props:
    capital:
      default: false
    options:
      type: Array
      default: -> []
    verify:
      default: false
    selected:
      default: undefined

    value:
      default: undefined

    disabled:
      default: false

    fullWidth:
      default: false

  data: ->
    selected_option: @options[0]

  methods:
    selectOption: (option) ->
      @selected_option = option
      @$emit('input', @selected_option.value)

    setSelectedOptionOrDefault: ->
      option = @options.findByProps(value: @selected_value) if @selected_value != undefined
      option ?= @options[0]
      @selected_option = option

  watch:
    options: (new_options) ->
      @setSelectedOptionOrDefault()

    selected: (new_value) ->
      if @selected_option.value != new_value
        @setSelectedOptionOrDefault()

    value: (new_value) ->
      if @selected_option.value != new_value
        @setSelectedOptionOrDefault()

  computed:
    # Removes all selected props and then use @value instead of this computed
    selected_value: ->
      if @selected != undefined then @selected else @value

  mounted: ->
    @setSelectedOptionOrDefault()




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/dropdown-select.vue